import {
  configureStore,
  injectStore,
  onUnauthorized,
} from 'getaway-data-layer';
import { getUser } from 'getaway-data-layer';

export const { store, persistor } = configureStore();
injectStore(store, persistor);

// Listen for unauthorized and pull user (web)
onUnauthorized(() => {
  // Pull user; getUser will clear auth on 401/403
  // @ts-ignore
  store.dispatch(getUser());
});
